import { useCallback } from "react";

import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import LeadService from "services/Lead";
import { useLeadsTable } from "hooks/useLeadsTable";
import { LeadsBulkActions } from "routes/leads/table/LeadsBulkActions";

export const LEADS_TABLE_CONSTANTS = {
  tableName: "leads",
  className: "Lead",
  exportTableName: null,
  header: "Leads",
  headerIcon: "address book outline",
};

const LeadsTableV3 = ({ scope, id }) => {
  const {
    filters,
    columns,
    events,
    queryKey,
    invalidateData,
    bulkUpdateStatus,
    enableTags,
  } = useLeadsTable({ scope, id });

  const fetchLeads = useCallback(
    async queryParams => {
      const nextQueryParams = getNextQueryParams(queryParams, columns);
      return LeadService.getLeads(scope, id, nextQueryParams);
    },
    [columns, scope, id]
  );

  const actionButtons = useCallback(
    ({ selectedIds, uncheckAll }) => (
      <LeadsBulkActions
        scope={scope}
        selectedIds={selectedIds}
        events={events}
        uncheckAll={uncheckAll}
        bulkUpdateStatus={bulkUpdateStatus}
      />
    ),
    [scope, events, bulkUpdateStatus]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={LEADS_TABLE_CONSTANTS.headerIcon}
      header={LEADS_TABLE_CONSTANTS.header}
      queryKey={queryKey}
      className={LEADS_TABLE_CONSTANTS.className}
      tableName={LEADS_TABLE_CONSTANTS.tableName}
      enableSearch
      enableSettings
      fetchData={fetchLeads}
      invalidateData={invalidateData}
      actionButtons={actionButtons}
      tagsDropdownParams={{ visible: enableTags }}
    />
  );
};

export default LeadsTableV3;
